<div class="container" fxLayout="column" fxLayoutAlign="cenetr end">
  <mat-icon class="icons" (click)="openNew()">open_in_new</mat-icon>
  <img [src]="data.imagePath" />
</div>
